<template>
  <el-dialog title="新增交付订单" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="客户名称:" prop="customerId">
        <el-select v-model="data.customerId" placeholder="请选择客户" @change="customerChange" filterable clearable style="width:100%">
          <el-option v-for="dict in customerList" :key="dict.id" :label="dict.customerName" :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="合同:" prop="contractId">
        <el-select v-model="data.contractId" placeholder="请选择合同" clearable style="width:100%">
          <el-option v-for="dict in contractList" :key="dict.contractId" :label="dict.contractNum" :value="dict.contractId"/>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人:" prop="managerId">
        <UserSelect v-model="data.managerId" placeholder="请选择负责人"></UserSelect>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {createCustomer, queryCustomerByName, listSimpleAll} from "@/api/crm/customer";
import { createDelivery } from "@/api/crm/order";
import { querySimpleList } from "@/api/crm/contract";
import UserSelect from "@/views/crm/components/userSelect";
import { mapState } from 'vuex'

export default {
  name: "AddCustomerDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      customerList: [],
      contractList: [],
      rules: {
        customerId: [
          {required: true, message: '请选择客户', trigger: 'change'}
        ],
        contractId: [
          {required: true, message: '请选择合同', trigger: 'change'}
        ],
        managerId: [
          {required: true, message: '请选择负责人', trigger: 'change'}
        ]
      },
      data: {
        customerId: null,
        contractId: null,
        managerId: null
      }
    };
  },
  created() {

  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (customerId, contractId) {
      this.data.managerId = this.currentUserId;
      if (customerId) {
        this.data.customerId = customerId
        this.data.contractId = contractId
        querySimpleList({deliveryCreateFlag : 1, customerId: customerId}).then(response => {
          this.contractList = response.data || [];
        });
      }
      this.visible = true
      // 获取到最新客户名称
      listSimpleAll().then(response => {
        this.customerList = response.data;
      });
    },
    customerChange (customerId) {
      this.contractList = [];
      this.data.contractId = null;
      if (customerId) {
        querySimpleList({deliveryCreateFlag: 1, customerId: customerId}).then(response => {
          this.contractList = response.data || [];
        });
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          createDelivery(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("新增成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
